<template>
  <div class="home" v-if="datasets">
    <Tit-Box></Tit-Box>
    <div class="banner">
      <div class="bannerinfor">
        <span class="banertit">数据集公开网站</span>
        <!-- <img class="banertite" src="~@/assets/Dataset public websi.svg"> -->
        <span class="banertite">DATASET PUBLIC WEBSITE</span>
        <div class="search">
          <el-input v-model="input" placeholder="请输入搜索内容"></el-input
          ><el-button>搜索</el-button>
          <i class="el-icon-search"></i>
        </div>
        <div class="banimg">
          <img src="~@/assets/icon.svg" />
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="nvinfo">
        <ul class="nvift">
          <li style="cursor: auto">来源：</li>
          <li v-for="(item0, index0) in nviftlist" :key="index0">
            {{ item0 }}
          </li>
        </ul>
        <ul class="nvifb">
          <li style="cursor: auto">来源：</li>
          <li v-for="(item1, index1) in nviftlisb" :key="index1">
            {{ item1 }}
          </li>
        </ul>
      </div>
    </div>
    <div class="content">
      <div class="contentinfo">
        <div class="computervison"></div>
        <div
          class="artical"
          v-for="(item2, index2) in articlelist"
          :key="index2"
        >
          <span class="spanbd"></span>
          <span @click="todetail" class="articalspan">{{ item2.tit }}</span>
          <span class="articalcontent">{{ item2.content }}</span>
          <div class="articalfooter">
            <span class="usericon">
              <img src="~@/assets/nicheng.svg" />
            </span>
            <span class="user">{{ item2.user }}</span>
            <span class="timeicon">
              <img src="~@/assets/时间.svg" />
            </span>
            <span class="user">{{ item2.date }}</span>
          </div>
        </div>
        <div class="contentfooter">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pagesize"
            :current-page="pagenum"
            background
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Bottom-Box></Bottom-Box>
  </div>
  <div class="dasets" v-else>404 NOTFOUND</div>
</template>

<script>
import "./home.less";
export default {
  data() {
    return {
      datasets: false,
      input: "",
      nviftlist: [
        "全部",
        "Computer vision",
        "Natural language processing",
        "Classification",
        "Object detection",
        "Speech recognition",
      ],
      nviftlisb: ["全部", "公共数据", "我的数据"],
      articlelist: [
        {
          tit: "带有丰富属性的个性化美学评估数据集 PRADA",
          content:
            "个性化图像美学评估 (PIAA) 由于其高度主观性而具有挑战性。人们的审美取决于多种因素，包括图像客观因素和主观因素。现有的 PIAA 数据库在数据标注多样性方面受到限制，已不能满足 PIAA 研究日益增长的需求。为了解决这个困境，我们对个性化图像美学进行了迄今为止最全面的主观研究，并引入了一个新的具有丰富属性的个性化图像美学数据库（PRADA）。该数据库由438个主题的31,220张带有注释的图像组成。PRADA具有丰富的标注，包括9个面向图像的客观属性和4个面向人的主观属性。此外，还提供了脱敏的标注员个人信息，例如个性特征，以支持对PIAA和用户画像的研究。提供了对注释数据的综合分析，统计研究表明审美偏好可以通过提出的主观属性来反映。我们还利用标注员信息作为条件先验，提出了一个带条件的 PIAA 模型。实验结果表明，条件PIAA模型的表现优于对照组，这也是首次尝试证明图像美学与主体角色如何相互作用，从而产生复杂的图像美学个性化品味。我们相信该数据库和相关分析将有助于进行下一代 PIAA 研究。该数据库将免费提供给研究界。",
          user: "璐璐",
          date: "2021-11-10",
        },
        {
          tit: "MUGE: A Multimodal Understanding And Generation Evaluation Benchmark",
          content:
            "The Multimodal Understanding and Generation Evaluation Benchmark (MUGE) is initiated by Data Analysis and Intelligence Laboratory, DAMO Academy, Alibaba Groudsfdsgvbadlkjhbvkfajdhguhreuhgoiuzgfahdslkhadsgvbdshfbalkdgfhiuarebpipuabgkafbiugarebgiuaefgiuaerhi",
          user: "璐璐",
          date: "2021-11-10",
        },
        {
          tit: "MUGE: A Multimodal Understanding And Generation Evaluation Benchmark",
          content:
            "The Multimodal Understanding and Generation Evaluation Benchmark (MUGE) is initiated by Data Analysis and Intelligence Laboratory, DAMO Academy, Alibaba Groudsfdsgvbadlkjhbvkfajdhguhreuhgoiuzgfahdslkhadsgvbdshfbalkdgfhiuarebpipuabgkafbiugarebgiuaefgiuaerhi",
          user: "璐璐",
          date: "2021-11-10",
        },
        {
          tit: "MUGE: A Multimodal Understanding And Generation Evaluation Benchmark",
          content:
            "The Multimodal Understanding and Generation Evaluation Benchmark (MUGE) is initiated by Data Analysis and Intelligence Laboratory, DAMO Academy, Alibaba Groudsfdsgvbadlkjhbvkfajdhguhreuhgoiuzgfahdslkhadsgvbdshfbalkdgfhiuarebpipuabgkafbiugarebgiuaefgiuaerhi",
          user: "璐璐",
          date: "2021-11-10",
        },
        {
          tit: "MUGE: A Multimodal Understanding And Generation Evaluation Benchmark",
          content:
            "The Multimodal Understanding and Generation Evaluation Benchmark (MUGE) is initiated by Data Analysis and Intelligence Laboratory, DAMO Academy, Alibaba Groudsfdsgvbadlkjhbvkfajdhguhreuhgoiuzgfahdslkhadsgvbdshfbalkdgfhiuarebpipuabgkafbiugarebgiuaefgiuaerhi",
          user: "璐璐",
          date: "2021-11-10",
        },
      ],
      total: 100,
      pagesize: 10,
      pagenum: 1,
    };
  },
  components: {},
  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    todetail() {
      this.$router.push("/data-sets-1");
    },
  },
  watch: {},
  created() {},
  mounted() {},
};
</script>
